import { InvalidApiResponseError } from "./errors";

/** Minimal delivery correlation guard, not a replacement for the generated DTO. */
export function assertMessageAcknowledgement(value: unknown, conversationId: string): void {
  if (!value || typeof value !== "object" || Array.isArray(value)
    || !("message_id" in value) || typeof value.message_id !== "string" || !value.message_id.trim()
    || !("conversation_id" in value) || value.conversation_id !== conversationId) {
    throw new InvalidApiResponseError(`/social/conversations/${encodeURIComponent(conversationId)}/messages`);
  }
}
